import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { combineLatest, Subscription } from 'rxjs';

@Component({
  selector: 'app-nations-cup',
  templateUrl: './nations-cup.component.html',
  styleUrls: ['./nations-cup.component.scss']
})
export class NationsCupComponent implements OnChanges, OnDestroy {
  @Input() competition: any;
  @Input() results: any[];
  public teamResults: any[] = [];
  public hasThirdRound: boolean = false;
  
  private teamsSubscription: Subscription;

  constructor(private firestore: AngularFirestore) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.results && changes.results.currentValue) {
      this.subscribeToTeamData(changes.results.currentValue);
    }
  }

  ngOnDestroy() {
    if (this.teamsSubscription) {
      this.teamsSubscription.unsubscribe();
    }
  }

  private subscribeToTeamData(results: any[]) {
    // Clean up previous subscription
    if (this.teamsSubscription) {
      this.teamsSubscription.unsubscribe();
    }

    const teamIds = [...new Set(results.map(r => r.teamId).filter(Boolean))];

    if (teamIds.length === 0) {
      this.teamResults = [];
      return;
    }

    const teamObservables = teamIds.map(teamId =>
      this.firestore.collection('teams').doc(teamId).valueChanges()
    );

    this.teamsSubscription = combineLatest(teamObservables).subscribe(teamsData => {
      const processedTeams = teamsData.map((team: any, index) => {
        const teamId = teamIds[index];
        const entries = results.filter(result => result.teamId === teamId);
        return {
          ...team,
          id: teamId, // Add teamId back for reference if needed
          entries: entries,
        };
      });

      // Sort by rank, handling non-numeric or missing ranks
      this.teamResults = processedTeams.sort((a, b) => {
        const rankA = a.rank ? parseInt(a.rank, 10) : Infinity;
        const rankB = b.rank ? parseInt(b.rank, 10) : Infinity;

        if (isNaN(rankA) && isNaN(rankB)) return 0;
        if (isNaN(rankA)) return 1; // Put teams without a valid rank at the end
        if (isNaN(rankB)) return -1;

        return rankA - rankB;
      });
    });
  }

  public encodeClip(string: string) {
    return btoa(string);
  }

  public isStruck(result: any): boolean {
    return result && typeof result === 'string' && result.includes('*');
  }

  public formatResult(result: any): string {
    if (result === null || result === undefined) {
      return '-';
    }
    return result.toString().replace('*', '');
  }
} 